import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { LogIn, ShieldAlert, Plus } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AdminLogin = () => {
  const [params] = useSearchParams();
  const denied = params.get('denied');
  const error = params.get('error');

  const handleLogin = () => {
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0b2027] flex items-center justify-center px-5 relative overflow-hidden">
      <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-[#17565f]/40 blur-3xl" />
      <div className="absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-[#2c8a95]/20 blur-3xl" />
      <div className="relative bg-white/5 border border-white/10 backdrop-blur-md p-10 md:p-12 max-w-md w-full text-center rounded-xl">
        <div className="inline-flex h-16 w-16 items-center justify-center rounded-full border-2 border-[#c9a24b] mb-8">
          <Plus className="h-8 w-8 text-[#c9a24b]" strokeWidth={2.5} />
        </div>
        <p className="text-[#c9a24b] uppercase tracking-[0.3em] text-xs mb-3">Living Hope</p>
        <h1 className="font-serif-display text-white text-3xl md:text-4xl mb-3">Admin Dashboard</h1>
        <p className="text-white/60 mb-8">Sign in with your approved Google account to manage events, sermons, and site content.</p>

        {denied && (
          <div className="flex items-start gap-3 bg-red-500/10 border border-red-400/30 text-red-200 text-sm p-4 rounded-lg mb-6 text-left">
            <ShieldAlert className="h-5 w-5 shrink-0 mt-0.5" />
            <span>That account isn’t authorized for admin access. Please sign in with an approved account.</span>
          </div>
        )}
        {error && (
          <div className="bg-red-500/10 border border-red-400/30 text-red-200 text-sm p-4 rounded-lg mb-6">
            Something went wrong signing in. Please try again.
          </div>
        )}

        <button
          onClick={handleLogin}
          className="btn-shine w-full inline-flex items-center justify-center gap-3 bg-[#c9a24b] text-[#0b2027] hover:bg-[#d8b566] px-8 py-4 uppercase tracking-[0.18em] text-sm font-700 transition-colors duration-300"
        >
          <LogIn className="h-5 w-5" /> Sign in with Google
        </button>

        <a href="/" className="inline-block mt-8 text-white/50 hover:text-white text-sm transition-colors">← Back to website</a>
      </div>
    </div>
  );
};

export default AdminLogin;
